export default __webpack_public_path__ + "static/media/de.61f8ce5e.svg";